// src/components/ui/Skeleton.jsx

import React from "react";
import "../../assets/styles/global.css";

function Skeleton() {
  return <div className="skeleton"></div>;
}

export default Skeleton;
